module.exports = __webpack_public_path__ + "static/media/foyer_1.c11bc515.jpg";